import { GoogleIcon, WhatsAppIcon } from './AuthControls'

/**
 * Divider + third-party auth buttons. Purely presentational — each auth view
 * wires its own handlers (e.g. login's WhatsApp starts the OTP sign-in flow,
 * register's is still a placeholder), so the same buttons can do different
 * jobs per view.
 */
export default function ExternalPathSync({ onGoogle, onWhatsApp }) {
  return (
    <>
      <div className="my-6 flex items-center justify-between select-none">
        <span className="w-1/4 h-px bg-stone-300/60" />
        <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-stone-400/80 whitespace-nowrap px-3">External Path Sync</span>
        <span className="w-1/4 h-px bg-stone-300/60" />
      </div>

      <div className="grid grid-cols-2 gap-3.5">
        <button type="button" onClick={onGoogle} className="flex items-center justify-center gap-2 border border-stone-200 bg-white hover:bg-stone-50 rounded-xl py-3 px-4 transition-all group duration-200 shadow-sm">
          <GoogleIcon />
          <span className="text-xs font-bold uppercase tracking-widest text-stone-600 group-hover:text-goldAccent transition-colors">Google</span>
        </button>

        <button type="button" onClick={onWhatsApp} className="flex items-center justify-center gap-2 border border-stone-200 bg-white hover:bg-stone-50 rounded-xl py-3 px-4 transition-all group duration-200 shadow-sm">
          <WhatsAppIcon />
          <span className="text-xs font-bold uppercase tracking-widest text-stone-600 group-hover:text-[#25D366] transition-colors">WhatsApp</span>
        </button>
      </div>
    </>
  )
}
